/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import teal from "material-ui/colors/teal";
import {
    Switch,
    Typography,
    withStyles
} from '@material-ui/core';
import PropTypes from "prop-types";
import axios from "axios";
import { BASE_URL, NODE_API_URL } from "../../../env_config";
import { SwalWarn } from "../Popup";
import { TracklistTable } from "./TracklistTable";
import { TracklistedStone } from "./TracklistedStone";
import { TracklistedStoneWise } from "./TracklistedStoneWise"
import Cookies from "js-cookie";
function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const CustomSwitch = withStyles({
    switchBase: {
        color: teal[300],
        '&$checked': {
            color: teal[500],
        },
        '&$checked + $track': {
            backgroundColor: teal[500],
        },
    },
    checked: {},
    track: {},
})(Switch);

export const TracklistMaster = (props) => {
    const [shortlistSwitch, setShortlistSwitch] = useState(true)
    const [swalopen, setSwalOpen] = useState(false)
    const [deleteObj, setDeleteObj] = useState(null)
    const [selectedrow,setSelectedRow] = useState(null)
    const [kycMessage,setKycMessage] = useState("")
    const [kycAlert,setAlert] = useState("")
    const [showData,setShowData] = useState(false)
    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/getKycMessage`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then((res) => {
            if(res?.data?.showprice){
                setShowData(true)
            }
            if (res && res?.data  && res?.data?.kycmessage && res?.data?.kycmessage?.kyc_status) {
                if(res?.data?.kycmessage?.message){
                    if(res?.data?.kycmessage?.kyc_status === "KYC_REJ"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message + ` ● Reason:${res?.data?.kycmessage?.reject_reason}`)
                    }
                    else if(res?.data?.kycmessage?.kyc_status === "NO_KYC"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message)
                    }
                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[])
    const DeleteRule = () => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/iframeDeleteRules`,
            headers: { "Content-Type": "application/json" },
            data: {
                user_id: deleteObj.user_id,
                rule_id: deleteObj.rule_id
            },
        }).then(res => {
            if (res && res.data) {
                // console.log(res.data.data,"CCMODEEEEWHITELABEL")
                props.setUpdateRules(!props.updaterule)
                setSwalOpen(false)
                setDeleteObj(null)
            }
        })
    }
    return (
        <>
            <SwalWarn show={swalopen} message={"Are you sure want to delete Rule?"} onHide={() => setSwalOpen(false)} onClose={() => setSwalOpen(false)} responseOnOk={() => DeleteRule()} />
            <div className="card custom-card border-0">
                <div className="card-body">
                    <div className="row align-content-start position-relative" style={{ minHeight: "74vh" }}>
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <h3>Tracklist Page</h3>
                            <div className="d-flex align-items-center m-1 border rounded px-5">
                                <span className="font-weight-bold text-muted small">Stone Wise</span>
                                <CustomSwitch
                                    checked={shortlistSwitch}
                                    onClick={() => setShortlistSwitch(!shortlistSwitch)}
                                />
                                <span className="font-weight-bold text-muted small">Name Wise</span>
                            </div>
                        </div>
                        {shortlistSwitch?
                            <div className="col-12">
                                {!selectedrow?
                                    <TracklistTable symbolname={props.symbolname} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} userinfo={props.userinfo} setSelectedRow={setSelectedRow}/>
                                :
                                    <TracklistedStone symbolname={props.symbolname} userinfo={props.userinfo} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} selectedrow={selectedrow} setSelectedRow={setSelectedRow} kycMessage={kycMessage} kycAlert={kycAlert} showData={showData}/>}
                            </div>
                        :
                            <div className="col-12">
                                <TracklistedStoneWise symbolname={props.symbolname} userinfo={props.userinfo} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} setSelectedRow={setSelectedRow} kycMessage={kycMessage} kycAlert={kycAlert} showData={showData}/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};
